module.exports = __webpack_public_path__ + "img/wallaudit_startup.1eaccf7b.png";